var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-view-debug"},[_c('h1',[_c('router-link',{attrs:{"to":{
        name: 'mainMenu'
      }}},[_vm._v(" ⬅ ")]),_vm._v(" Gamepad debugging ")],1),_c('p',[_c('button',{on:{"click":_vm.updateInputValues}},[_vm._v(" Get values ")])]),_c('dump',{attrs:{"value":_vm.dump}}),_c('div',{staticClass:"c-view-debug-buttons"},_vm._l((_vm.inputs),function(value,key){return _c('div',{key:key,staticClass:"c-view-debug-button",class:{
        'c-view-debug-button-pressed': !!value,
        'c-view-debug-button-not-pressed': !value
      },style:({
        backgroundColor: 'rgba(0, 0, 0, ' + Math.abs(value * 0.5) + ')'
      })},[_vm._v(" "+_vm._s(key)+": "+_vm._s(value)+" ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }